
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { stringMixin } from "@/mixins";
import { AlarmQueueFilter } from "@/store/eventqueue/types";
import vSelect3 from "vselect3";

const { isNullOrWhitespace } = stringMixin.methods;

@Component({
	components: {
		"v-select-3": vSelect3,
	}
})
export default class AlarmQueueFilterSelect extends Vue {
	@Prop() public value: string;
	@Prop() public readonly options: AlarmQueueFilter[];

	private selectedFilters: number[] = [];

	@Watch("value", { immediate: true})
	private valueChange(newValue: string): void {
		try {
			this.selectedFilters = JSON.parse(newValue);
		}
		catch(e) {
			console.error("Error parsing selected filters: ", e);
		}
	}

	private submitChange(): void {
		try {
			let valueAsString = JSON.stringify(this.selectedFilters);
			this.$emit("input", valueAsString);
		}
		catch(e) {
			console.error("Error serializing selection: " + e);
		}
	}
}
